import {Roles} from '@enums/Roles';

// Which panel pages each role opens, and where it starts (spec of 03/11/2026). The API applies the same rules to the
// data: this only keeps a role away from pages it has no use for, also when the address is typed by hand.
// - superadmin and backoffice: everything but "my QR" (only field technicians have a QR)
// - remote technician: the rooms where someone calls him, his conversations, his documents; no dashboard
// - field technician: only his QR, to enter from the headset or the phone
const ALL_BUT_QR = ['/dashboard', '/support', '/conversations', '/filemanager', '/users/technicians', '/devices', '/users/user-profile'];

export const ROLE_PAGES: Record<number, { home: string, pages: string[] }> = {
  [Roles.SUPER_ADMIN]: {home: '/dashboard', pages: ALL_BUT_QR},
  [Roles.MANAGEMENT_SYSTEM]: {home: '/dashboard', pages: ALL_BUT_QR},
  [Roles.OPERATOR_BO]: {home: '/support/room/list', pages: ['/support', '/conversations', '/filemanager', '/users/user-profile']},
  [Roles.TECHNICIAN]: {home: '/users/qrcode', pages: ['/users/qrcode', '/users/user-profile']},
};

export function roleHome(role: number | undefined | null): string {
  return (role && ROLE_PAGES[role]?.home) || '/dashboard';
}

export function roleOpens(role: number | undefined | null, url: string): boolean {
  const pages = role ? ROLE_PAGES[role]?.pages : undefined;
  if (!pages) {
    return true;
  }
  const path = url.split(/[?#]/)[0];
  return pages.some(page => path === page || path.startsWith(page + '/'));
}
